import React from 'react';
import { getAPIImage, displayLoader, getMatchURL, getDate } from '../utils';
import { TeamLogo } from './teamLogo';



/**
 * Small Matchbox Component
 */
const SmallMatchBox = (props) => {
    const { 
        data = null,
        link   = '#',
        ...restProps 
    } = props;
    if ( !data ) return;

    // Get the state
    let state;
    let altTitle;
    switch (data.liveStatus) {
        case 'PLAYED':
            state = 'played';
            break;
        case 'SCHEDULED':
        case 'POSTPONED':
        case 'CANCELED':
            state = 'scheduled';
            break;
        case 'PLANNED':
            state = 'scheduled';
            altTitle = 'Planned Match';
            break;
        default:
            state = 'running';
            break;
    }

    // Get the winner
    let winner;
    if ( state == 'played' ) {
        // Check for penalty wins first
        if ( data.awayTeamResult.hasOwnProperty('penaltyWin') && data.awayTeamResult.penaltyWin ) {
            winner = 'away';
        } else if ( data.homeTeamResult.hasOwnProperty('penaltyWin') && data.homeTeamResult.penaltyWin ) {
            winner = 'home';
        } else if ( data.awayTeamResult.hasOwnProperty('current') && data.homeTeamResult.hasOwnProperty('current') ) {
            // Check for wins without penalties
            if ( data.awayTeamResult.current > data.homeTeamResult.current ) {
                winner = 'away';
            } else if ( data.awayTeamResult.current < data.homeTeamResult.current ) {
                winner = 'home';
            } else {
                winner = 'tie';
            }
        }
    }

    // Set up the time
    let time = '';
    if ( data.hasOwnProperty('displayTime') ) {
        time = data.displayTime;
    } else if ( data.hasOwnProperty('dateTimeUTC') ) {
        time = getDate(data.dateTimeUTC, 'medium');
    }

    /**
     * Get other necessary data
     */
    let url = getMatchURL(data.id);

    // Set up class list
    let classes = 'smallMatch';
    classes += ' smallMatch--' + state;

    return (
        <a href={url} className={classes}>
            <div className="smallMatch__teamStats">

                { data.homeTeam ? (
                    <div className="smallMatch__team smallMatch__team--home" data-winner={winner == 'home' || winner == 'tie' ? 'true' : 'false' }>
                        { data.homeTeam && data.homeTeam.hasOwnProperty('picture') ? (
                            <TeamLogo defaultPictureId={data.homeTeam.picture} />
                        ) : '' }
                        <div className="smallMatch__teamName">{data.homeTeam.name}</div>
                        { state == 'scheduled' ? '' : (
                            <div className="smallMatch__teamScore">{ data.homeTeamResult ? data.homeTeamResult.current : '' }</div>
                        ) }
                    </div>
                ) : '' }

                { data.awayTeam ? (
                    <div className="smallMatch__team smallMatch__team--visitor" data-winner={winner == 'away' || winner == 'tie' ? 'true' : 'false' }>
                        { data.awayTeam.hasOwnProperty('picture') ? (
                            <TeamLogo defaultPictureId={data.awayTeam.picture} />
                        ) : '' }
                        <div className="smallMatch__teamName">{ data.awayTeam.name }</div>
                        { state == 'scheduled' ? '' : (
                            <div className="smallMatch__teamScore">{ data.awayTeamResult ? data.awayTeamResult.current : '' }</div>
                        ) }
                    </div>
                ) : '' }

                { altTitle ? (
                    <div className="smallMatch__team smallMatch__team--altTitle">
                        <div className="smallMatch__teamName">{ altTitle }</div>
                    </div>
                ) : '' }

            </div>

            { state == 'scheduled' ? (
                <div className="acaH5--alt smallMatch__schedule">
                    <div className="smallMatch__scheduleCompetition">{ data.competition ? data.competition.name : '' }</div>
                    <div className="smallMatch__scheduleDatetime">{ time }</div>
                </div>
            ) : (
                <div className="acaH5 smallMatch__currentTime">{ data.currentMinute }</div>
            ) }   

        </a>
    );
}



/**
 * Export
 */
export { SmallMatchBox };